import { PublicRouterService } from './public-router';
export function routerDataServiceFactory(widgetPluginService, wixUserAPI, wixWindowAPI) {
  return widgetPluginService.getIsWidgetPlugin() ? {
    getRouteData: widgetPluginService.getMembers.bind(widgetPluginService)
  } : new PublicRouterService(wixUserAPI, wixWindowAPI);
}
//# sourceMappingURL=route-data.js.map